import { useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { toggleMute, isMuted, initAudio } from "@/lib/sound";

export default function SoundToggle() {
  const [muted, setMuted] = useState(isMuted());
  const onClick = () => {
    initAudio();
    const m = toggleMute();
    setMuted(m);
  };
  return (
    <button data-testid="sound-toggle" onClick={onClick} aria-label="Toggle sound"
      className="text-muted-foreground hover:text-primary transition-colors">
      {muted ? <VolumeX className="w-5 h-5" /> : <Volume2 className="w-5 h-5" />}
    </button>
  );
}
